import PropTypes from 'prop-types'
import React, { Component, useEffect, useState } from 'react'
import { HTTP } from '../../api/http-common';
import { Link } from 'react-router-dom';
import CouponCard from '../../component/CouponCard';
import Slider from 'react-slick/lib/slider';
import { SearchIcon } from "lucide-react";
import { Chart } from "react-google-charts";

// export class MemberDashboard extends Component {
function MemberDashboard() {
  const user_id = (localStorage.getItem('user_id'));
  const access_token = (localStorage.getItem('access_token'));

  const [totalCoupons, setTotalCoupons] = useState(0);
  const [expiredCoupons, setExpiredCoupons] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [dataSet, setDataSet] = useState([]);

  const [coupons, setCoupons] = useState([]);
  const [error, setError] = useState(null);
  const [activeCoupons, setActiveCoupons] = useState(0);

  const [inactiveCoupons, setInactiveCoupons] = useState(0);

  const [searchValue, setSearchValue] = useState("");
  const [allCoupons, setAllCoupons] = useState([]);

  const [businessCategoriesData, setBusinessCategoriesData] = useState([
    ["Business Category", "Coupon Count"],
  ]);

  const filteredCoupons = allCoupons.filter((coupon) =>
    coupon.coupon_code.toLowerCase().includes(searchValue.toLowerCase())
  );

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1 }
      }
    ]
  };

  const loadDashboard = async () => {
    let config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    }
    let fields = {

    };
    HTTP.post(`user/members/dashboard/${user_id}`, fields, config)
      .then((response) => {
        const data = response.data;

        if (response.status === 200) {
          setCoupons(data.recently_viewed_coupons);
          setAllCoupons(data.all_coupons);
          setTotalCoupons(data.total_count_coupons);
          setTotalUsers(data.total_count_member);
          // setDataSet(data.bar_chart_dataset);
          // setFilteredCoupons(data.trending_coupons)
          setActiveCoupons(data.active_count);
          setInactiveCoupons(data.inactive_count);
          setExpiredCoupons(data.expired_count);
          if (data.business_categories && Array.isArray(data.business_categories)) {
            const formattedData = [
              ["Business Category", "Coupon Count"],
              ...data.business_categories.map(category => [category.name, category.total_coupon_count]),
            ];
            setBusinessCategoriesData(formattedData);
          }
          //
        }
        if (response.status === 204) {
          // setAaMasters([])
        }
      })
      .catch((error) => {
        console.log(error)
        // setRerenderFlag(true);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };

  const getCouponTypeData = () => {
    const typeLabels = {
      1: "Flat Discount",
      2: "Percentage Discount",
    };

    const typeCounts = allCoupons.reduce((acc, coupon) => {
      const type = typeLabels[coupon.coupon_type] || "Unknown";
      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {});

    return [["Coupon Type", "Count"], ...Object.entries(typeCounts)];
  };

  const couponTypeData = getCouponTypeData();

  useEffect(() => {
    loadDashboard();
  }, [])

  // render() {
  return (
    <>
      <div className="container mx-auto p-5">
        <h4 className="font-semibold text-[30px] text-center py-2">Coupon Statistics</h4>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
          <div className="bg-white p-5 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-center mb-3">Coupon Types</h3>
            <Chart
              chartType="PieChart"
              data={couponTypeData}
              options={{ title: "Coupon Types", pieHole: 0.3 }}
              width="100%"
              height="300px"
            />
          </div>

          {/* <div className="bg-white p-5 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-center mb-3">Coupon Status</h3>
            <Chart
              chartType="PieChart"
              data={couponStatusData}
              options={{ title: "Coupon Status", is3D: true }}
              width="100%"
              height="300px"
            />
          </div> */}
          <div className="bg-white p-5 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-center mb-3">Business Categories</h3>
            <Chart
              chartType="PieChart"
              data={businessCategoriesData}
              options={{ title: "Business Categories", is3D: true }}
              width="100%"
              height="300px"
            />
          </div>
        </div>
      </div> 
      <h4 className='font-semibold text-[40px] text-center py-2 pb-0 mb-0'>Recently Used Coupon(s)</h4>
      <Slider {...sliderSettings}>
        {coupons.map((coupon, index) => (
          <div key={coupon.id} className="p-4">
            <CouponCard coupon={coupon} />
          </div>
        ))}
      </Slider>
      <div className="custom-dashboard-container">
        <div className="custom-dashboard-stats">
          <div className="bg-white p-5 rounded-lg shadow w-full">
            <h3 className="font-bold text-xl mb-5">Coupon History</h3>
            <div className="flex justify-between items-center mb-5">
              <div className="w-1/2 flex border-b border-gray-300">
                <span className="w-4">
                  <SearchIcon className="w-4" />
                </span>
                <input
                  type="text"
                  placeholder="Search Deals"
                  className="admin-table-search-input w-full"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setSearchValue(e.target.value);
                    }
                  }}
                />
              </div>
            </div>
            {filteredCoupons.length > 0 ? (
              <table className="admin-table-table mt-5 w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="admin-table-th">Code</th>
                    <th className="admin-table-th">Coupon Type</th>
                    <th className="admin-table-th">Coupon Value</th>
                    <th className="admin-table-th">Minimum Purchase</th>
                    <th className="admin-table-th">Start Date</th>
                    <th className="admin-table-th">Expiration Date</th>
                    <th className="admin-table-th">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCoupons.map((coupon) => (
                    <tr key={coupon.id} className="border border-gray-300">
                      <td className="admin-table-th-td">{coupon.coupon_code}</td>
                      <td className="admin-table-th-td">{coupon.coupon_type === 1 ? "Flat Discount" : "Percentage Discount"}</td>
                      <td className="admin-table-th-td">{coupon.coupon_value}</td>
                      <td className="admin-table-th-td">{coupon.minimum_purchase}</td>
                      <td className="admin-table-th-td">{new Date(coupon.start_date).toLocaleDateString()}</td>
                      <td className="admin-table-th-td">{new Date(coupon.expiration_date).toLocaleDateString()}</td>
                      <td className="admin-table-th-td">{coupon.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="text-gray-500 mt-4">No Deals available.</p>
            )}
          </div>

        </div>
      </div>
    </>
  )
  // }
}

export default MemberDashboard